var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { title: "编辑字段描述", "mask-closable": false, width: "800" },
      model: {
        value: _vm.showColumnDescModal,
        callback: function ($$v) {
          _vm.showColumnDescModal = $$v
        },
        expression: "showColumnDescModal",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "table-container",
          staticStyle: {
            "max-height": "350px",
            "overflow-y": "auto",
            "margin-bottom": "20px",
          },
        },
        [
          _c("stand-pagination-table", {
            attrs: {
              columns: _vm.mainTable.columns,
              data: _vm.mainTable.data,
              loading: _vm.mainTable.loading,
              "table-search": _vm.mainTable.tableSearch,
              "table-load-event": _vm.getColumnDesc,
              totalSummaryFieldDatas: _vm.mainTable.sumData,
              autoHeight: true,
              showPage: true,
            },
          }),
        ],
        1
      ),
      _c("Divider", [_vm._v("编辑区域")]),
      _c(
        "Form",
        {
          ref: "columnForm",
          attrs: {
            model: _vm.columnDescForm,
            rules: _vm.formRules,
            "label-width": 80,
          },
        },
        [
          _c(
            "FormItem",
            { attrs: { label: "字段名", prop: "ColumnName" } },
            [
              _c("Input", {
                attrs: { placeholder: "请输入字段名" },
                model: {
                  value: _vm.columnDescForm.ColumnName,
                  callback: function ($$v) {
                    _vm.$set(_vm.columnDescForm, "ColumnName", $$v)
                  },
                  expression: "columnDescForm.ColumnName",
                },
              }),
            ],
            1
          ),
          _c(
            "FormItem",
            { attrs: { label: "字段描述", prop: "DescName" } },
            [
              _c("Input", {
                attrs: { placeholder: "请输入字段描述" },
                model: {
                  value: _vm.columnDescForm.DescName,
                  callback: function ($$v) {
                    _vm.$set(_vm.columnDescForm, "DescName", $$v)
                  },
                  expression: "columnDescForm.DescName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("Button", { on: { click: _vm.handleCancel } }, [_vm._v("取消")]),
          _c(
            "Button",
            {
              attrs: { type: "primary", loading: _vm.isSaving },
              on: { click: _vm.handleSave },
            },
            [_vm._v("\n            保存\n        ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }